import { render, staticRenderFns } from "./AAprobarPrograma.vue?vue&type=template&id=6cdf020c"
import script from "./AAprobarPrograma.vue?vue&type=script&lang=js"
export * from "./AAprobarPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports